var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMissouri(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "288px",
    height: "288px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M253.399,198.205c-5.831,2.43-14.579-11.661-11.175-12.635c3.4-0.97-2.433-17.492-3.564-20.894 c-1.134-3.402-4.697-3.402-10.529-4.372c-5.831-0.973-16.522-13.122-17.98-17.982c-1.455-4.856,9.72-19.922,6.805-23.809 c-2.916-3.887-17.008-2.914-20.004-3.887c-2.998-0.973,0-12.635,0-12.635c-26.807-13.119-26.643-27.209-29.56-36.93 c-2.613-8.709,1.212-9.61,2.034-9.706c-1.654-0.199-9.811-9.487-9.811-9.487l-22.513,0.639L27.847,49.6 c1.764,4.729,3.486,8.175,3.486,8.175l11.176,16.521l6.317,6.317c0,0,6.803-1.458,6.803,2.429c0,3.889-4.86,6.316-6.803,10.203 c-1.943,3.89,17.818,18.953,17.818,18.953v91.515v23.459l70.459-2.566l84.388-3.074c0,0,3.239,3.561,4.211,5.828 c0.972,2.27-7.127,9.072-8.422,9.394c-1.295,0.327,0,6.155,0,6.155h21.381l5.021-24.295c0,0,2.428,1.457,9.718-7.287 C260.687,202.58,253.399,198.205,253.399,198.205z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissouri);
export default __webpack_public_path__ + "static/media/missouri.86c9b38a9357343e45904cf5cf6d017c.svg";
export { ForwardRef as ReactComponent };